/* -----------------Globals--------------- */
import { isNativeStorageDisabled } from "./common";

type StorageClient = {
	set: (key: string, value: string) => void;
	getString: (key: string) => string | undefined;
	delete: (key: string) => void;
	clearAll: () => void;
};

const createMemoryStorage = (): StorageClient => {
	const storageMap = new Map<string, string>();

	return {
		set: (key, value) => {
			storageMap.set(key, value);
		},
		getString: (key) => storageMap.get(key),
		delete: (key) => {
			storageMap.delete(key);
		},
		clearAll: () => {
			storageMap.clear();
		},
	};
};

const createStorage = (): StorageClient => {
	if (isNativeStorageDisabled()) {
		return createMemoryStorage();
	}

	try {
		const module = require("react-native-mmkv") as {
			MMKV?: new () => StorageClient;
		};
		if (!module.MMKV) {
			return createMemoryStorage();
		}
		return new module.MMKV();
	} catch (error) {
		if ((globalThis as { __DEV__?: boolean }).__DEV__) {
			console.warn(
				"[storage] MMKV unavailable, falling back to in-memory storage.",
				error,
			);
		}
		return createMemoryStorage();
	}
};

export const storage = createStorage();

const keys = {
	isDarkMode: "isDarkMode",
};

export const storeKey = (key: keyof typeof keys, value: unknown) => {
	storage.set(key, JSON.stringify(value || ""));
};

export const deleteKey = (key: keyof typeof keys) => {
	storage.delete(key);
};

export const retrieveKey = (key: keyof typeof keys) => {
	const result = storage.getString(key);
	if (result === undefined) {
		return null;
	}
	return JSON.parse(result);
};
